import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "redux/store";

type StateType = {
    AccountActivationStep: 'Agreement' | 'ActivedSuccessfully' | 'AlreadyActived' | 'ShouldRegister' | 'SendingRequest',
    isConfirmRivasOpen: boolean;
}

const initialState: StateType = {
    AccountActivationStep: 'Agreement',
    isConfirmRivasOpen: false,
}

export const AccountActivationSlice = createSlice({
    name: 'AccountActivation',
    initialState,
    reducers: {
        setAccountActivationStep: (state, { payload }: PayloadAction<StateType['AccountActivationStep']>) => {
            state.AccountActivationStep = payload;
        }
    },
})


export const { setAccountActivationStep } = AccountActivationSlice.actions;

export const getAccountActivationStep = (state: RootState) => state.AccountActivationSlice.AccountActivationStep

export default AccountActivationSlice.reducer;